import { ref, computed, readonly } from 'vue'
import api from '@/services/api'
import { useToaster } from '@/composables/game/toasters'
import { syncPlayer } from '@/composables/game/player'

const v1Stars = ref<number>(0)
const v1StarsFromUsdt = ref<number>(0)
const usdtCentsBalance = ref<number>(0)
const showClaimV1StarsModal = ref<boolean>(false)
const isClaimingV1Stars = ref<boolean>(false)

export const useV1Stars = () => {
  const { notify } = useToaster()

  const hasV1Stars = computed(() => v1Stars.value > 0 || v1StarsFromUsdt.value > 0)
  const totalV1Stars = computed(() => v1Stars.value + v1StarsFromUsdt.value)

  async function fetchV1Stars(): Promise<boolean> {
    try {
      const response = await api.getV1Stars()
      v1Stars.value = response.stars
      v1StarsFromUsdt.value = response.starsFromUsdt
      usdtCentsBalance.value = response.usdtCentsBalance
      return hasV1Stars.value
    } catch (error) {
      console.error('Failed to fetch V1 stars:', error)
      return false
    }
  }

  async function claimV1Stars(): Promise<boolean> {
    if (isClaimingV1Stars.value) return false

    isClaimingV1Stars.value = true
    try {
      await api.claimV1Stars()
      await syncPlayer()
      notify({ type: 'success', title: 'Stars claimed successfully' })
      v1Stars.value = 0
      v1StarsFromUsdt.value = 0
      usdtCentsBalance.value = 0
      showClaimV1StarsModal.value = false
      return true
    } catch (error) {
      console.error('Failed to claim V1 stars:', error)
      notify({ type: 'error', title: 'Failed to claim stars. Please try again.' })
      return false
    } finally {
      isClaimingV1Stars.value = false
    }
  }

  function openClaimV1StarsModal() {
    showClaimV1StarsModal.value = true
  }

  function closeClaimV1StarsModal() {
    showClaimV1StarsModal.value = false
  }

  return {
    v1Stars: readonly(v1Stars),
    v1StarsFromUsdt: readonly(v1StarsFromUsdt),
    usdtCentsBalance: readonly(usdtCentsBalance),
    showClaimV1StarsModal,
    isClaimingV1Stars: readonly(isClaimingV1Stars),
    hasV1Stars,
    totalV1Stars,
    fetchV1Stars,
    claimV1Stars,
    openClaimV1StarsModal,
    closeClaimV1StarsModal,
  }
}
